import 'css-chunksrc/client/scenes/workloads/wbs/task/allocationsList/details/allocation/allocatedHours/styles.scss';export default {
  "allocatedHours": "_allocatedHours_ioa4b_1",
  "edition": "_edition_ioa4b_7",
  "input": "_input_ioa4b_11",
  "text": "_text_ioa4b_31"
};